<template>
    <div class="col-sm-12 px-2">
      <h4 class="form-header">{{ $t('menu.default_task_types')}}</h4>
      <div v-if="selectedTaskTypes.length > 0" class="row">
        <div class="col-sm-12 inspectable-container p-2">
          <div
            v-for="item in selectedTaskTypes"
            :key="item.id"
            :class="{'d-inline' : true}"
          >
            <span
              class="inspectables inspectables-selected"
              @click="updateTaskTypeSelection(item)"
            >
              {{ item.name }}
              <strong>
                X
              </strong>
            </span>
          </div>
        </div>
      </div>
      <div v-else class="row mb-3">
        <span>
          {{ $t('contracts.no_selected_task_types') }}
        </span>
      </div>

      <div class="col-sm-12">
        <!-- Task type list -->
       <h4 class="form-header" v-if="selectedTaskTypes.length !== taskTypes.length">
          {{ $t('contracts.select_task_type') }}
        </h4>
        <div class="row inspectable-container px-2" style="max-height: 70vh !important;">
              <div v-for="item in taskTypes" :key="item.id"
                   class="col-sm-6 col-md-4 col-lg-3 col-xl-2 inline inspectables nopads"
                   :class="{ 'inspectables-disabled' : isSelected(item.id) }"
                   @click="updateTaskTypeSelection(item)"
              >
                <span>{{ item.name }}</span>
              </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 d-flex justify-content-end mt-3">
      <button
        class="btn btn-success form-button"
        :disabled="loading"
        @click.stop="submitTaskTypes"
      >
        <span>
          {{ $t('common.save') }}
        </span>
      </button>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'DefaultTaskTypes',
    components: {},
    mixins: [restApi],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            defaultTaskTypesLoading: false,
            taskTypesLoading: false,
            taskTypes: [],
            selectedTaskTypes: []
        }
    },

    created: function () {
        this.fetchTaskTypes()
        this.fetchDefaultTaskTypes()
    },

    methods: {
        fetchDefaultTaskTypes: function () {
            this.defaultTaskTypesLoading = true
            this.isLoading()
            this.restFetch(this.defaultTaskTypeUrl, this.handleDefaultTaskTypes, this.onDefaultTaskTypeLoaded)
        },

        handleDefaultTaskTypes: function (results) {
            this.onDefaultTaskTypeLoaded()
            results.data.forEach(item => {
                this.selectedTaskTypes.push(item)
            })
        },

        onDefaultTaskTypeLoaded: function () {
            this.defaultTaskTypesLoading = false
            this.isLoading()
        },

        fetchTaskTypes: function () {
            this.taskTypesLoading = true
            this.isLoading()
            this.restFetch(this.taskTypeUrl, this.handleTaskTypes, this.onTaskTypeLoaded)
        },

        handleTaskTypes: function (response) {
            this.taskTypes = response.data
            this.onTaskTypeLoaded()
        },

        onTaskTypeLoaded: function () {
            this.taskTypesLoading = false
            this.isLoading()
        },

        indexOfTaskType: function (id) {
            return this.selectedTaskTypes.findIndex(function (obj) {
                return obj.id === id
            })
        },

        isSelected: function (id) {
            let index = this.indexOfTaskType(id)
            return index >= 0
        },

        updateTaskTypeSelection: function (taskType) {
            let index = this.selectedTaskTypes.findIndex(item => item.id === taskType.id)
            if (index >= 0) {
                this.selectedTaskTypes.splice(index, 1)
            } else {
                this.selectedTaskTypes.push(taskType)
            }
        },

        submitTaskTypes: function () {
            this.loading = true
            let ids = []
            this.selectedTaskTypes.forEach(item => ids.push(item.id))
            this.restAdd(this.defaultTaskTypeUrl, {task_types: ids}, this.submitTaskSuccess, this.submitTaskFail)
        },

        submitTaskSuccess: function () {
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.loading = false
        },

        submitTaskFail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        isLoading: function () {
            this.loading = this.defaultTaskTypesLoading || this.taskTypesLoading
        }
    }
}
</script>
